import styled from 'styled-components';

export const IconInput = styled.div`
  position: relative;

  > :last-child {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 0;
  }
`;
